export const currentUserPath = (): string => {
  return '/users/current';
}